// Login ke server (/api/login). Penanda sesi disimpan di perangkat supaya aplikasi
// tetap bisa dibuka saat offline oleh perangkat yang pernah login.
import { store } from '../core/storage.js';
import { MODE_DEMO } from './riwayat.js';
import { slugNama } from '../../lib/riwayat.js';
const KUNCI = 'tka-sesi';

// Mode demo (artifact tanpa server): kata sandi dicek di browser terhadap hash yang
// disisipkan saat build (DEMO_PASSWORD_HASH), sesi hanya disimpan di perangkat.
async function sha256Hex(s) {
  const b = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(s));
  return [...new Uint8Array(b)].map(x => x.toString(16).padStart(2, '0')).join('');
}
async function masukDemo(nama, kataSandi) {
  if ((await sha256Hex(kataSandi.trim())) !== __DEMO_HASH__) return { ok: false, pesan: 'Kata sandinya belum tepat. Tanyakan ke guru atau orang tuamu, ya.' };
  simpan(nama, Math.floor(Date.now() / 1000) + 30 * 86400, slugNama(nama));
  return { ok: true, nama, akun: slugNama(nama) };
}

const simpan = (nama, exp, akun) => store.set(KUNCI, { nama, exp, akun });
const penanda = () => { const p = store.get(KUNCI, null); return p && p.exp * 1000 > Date.now() ? p : null; };

async function kirim(url, opsi = {}) {
  const r = await fetch(url, { credentials: 'same-origin', ...opsi });
  let data = {};
  try { data = await r.json(); } catch (e) { /* bukan JSON */ }
  return { r, data };
}

export async function cekSesi() {
  if (MODE_DEMO) { const p = penanda(); return p ? { ok: true, nama: p.nama, akun: p.akun || slugNama(p.nama) } : { ok: false }; }
  try {
    const { r, data } = await kirim('/api/session');
    if (r.ok && data.ok) { simpan(data.nama, data.exp, data.akun); return { ok: true, nama: data.nama, akun: data.akun }; }
    if (r.status === 401) { store.del(KUNCI); return { ok: false }; }
  } catch (e) {
    const p = penanda();
    if (p?.akun) return { ok: true, nama: p.nama, akun: p.akun, offline: true };
  }
  return { ok: false };
}

/**
 * @param {string} [pilih] jawaban atas pertanyaan "ganti nama atau anak lain?": id akun, atau 'baru'
 * @returns {Promise<{ok, nama?, akun?, offline?, pesan?, konfirmasi?: Array<{id, nama}>}>}
 */
export async function masuk(nama, kataSandi, pilih) {
  if (MODE_DEMO) return masukDemo(nama, kataSandi);
  try {
    const { r, data } = await kirim('/api/login', { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify({ nama, kataSandi, ...(pilih ? { pilih } : {}) }) });
    if (r.ok && data.ok) { simpan(data.nama, data.exp, data.akun); return { ok: true, nama: data.nama, akun: data.akun }; }
    // Perangkat ini sudah dipakai akun lain dengan nama berbeda: tanya anak dulu.
    if (r.status === 409 && Array.isArray(data.konfirmasi)) return { ok: false, konfirmasi: data.konfirmasi };
    if (data.khusus && data.pesan) return { ok: false, pesan: data.pesan };
    if (r.status === 401) return { ok: false, pesan: 'Kata sandinya belum tepat. Tanyakan ke guru atau orang tuamu, ya.' };
    if (r.status === 404) return { ok: false, pesan: 'Layanan login belum tersedia. Jalankan aplikasi lewat Cloudflare Pages (lihat README).' };
    return { ok: false, pesan: data.pesan || `Server sedang bermasalah (kode ${r.status}). Coba lagi sebentar lagi.` };
  } catch (e) {
    const p = penanda();
    if (p?.akun) return { ok: true, nama: p.nama, akun: p.akun, offline: true };
    return { ok: false, pesan: 'Tidak ada koneksi internet. Sambungkan dulu untuk masuk pertama kali.' };
  }
}

export async function keluar() {
  store.del(KUNCI);
  // Hapus konten R2 yang tersimpan di perangkat (dipakai bersama di kelas).
  try { await caches.delete('konten-r2'); await caches.delete('riwayat-r2'); } catch (e) { /* Cache API tidak tersedia */ }
  if (MODE_DEMO) return;
  try { await kirim('/api/logout', { method: 'POST' }); } catch (e) { /* offline */ }
}
